<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <TardyDetentionsTable></TardyDetentionsTable>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import TardyDetentionsTable from "@/v3components/Datatables/TardyDetentionsTable.vue"
export default {
  name: "TardyDetentions",
  components: { TardyDetentionsTable }
}
</script>
